import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import { ReactComponent as StopwatchSvg } from './assets/stopwatch.svg';

const StopwatchIcon = React.forwardRef((args, ref) => <SvgIcon component={StopwatchSvg} ref={ref} {...args} />);

export default StopwatchIcon;
